import React from 'react'

import { NotificationsDropdownSidebar } from './NotificationsDropdownSidebar'
import { NotificationsDropdownTopBar } from './NotificationsDropdownTopBar'

export const NotificationsDropdown: React.FC<{
  variant?: 'navbar' | 'sidebar'
}> = ({ variant = 'navbar' }) => {
  switch (variant) {
    case 'sidebar':
      return <NotificationsDropdownSidebar />
    default:
      return <NotificationsDropdownTopBar />
  }
}
